import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "shared/icons";
import i18n from "shared/i18n";
import { withTranslations } from "shared/utils";
import { LINKS, ROUTES } from "shared/config";
import CardExpensesLink from "widgets/Navbar/ui/CardExpensesLink/CardExpensesLink";

export const getNavLinks = withTranslations("Shared", (callback) => {
  const links = [
    {
      label: i18n.t("start", { ns: "Shared" }),
      link: ROUTES.home,
      icon: <FontAwesomeIcon icon={Icons.home} />,
      displayOn: ["drawer", "footer"],
    },
    {
      label: i18n.t("new_travel", { ns: "Shared" }),
      link: ROUTES.request.new_travel,
      icon: <FontAwesomeIcon icon={Icons.plane} />,
      displayOn: ["drawer", "footer", "navbar"],
    },
    {
      label: i18n.t("new_expense", { ns: "Shared" }),
      link: ROUTES.request.new_expense,
      icon: <FontAwesomeIcon icon={Icons.euroSign} />,
      displayOn: ["drawer", "footer", "navbar"],
    },
    {
      label: i18n.t("requests", { ns: "Shared" }),
      link: ROUTES.request.user_queue,
      icon: <FontAwesomeIcon icon={Icons.list} />,
      displayOn: ["drawer", "footer", "navbar"],
    },
    {
      label: i18n.t("card_expenses", { ns: "Shared" }),
      displayOn: ["drawer", "navbar"],
      render: (displayOn) => <CardExpensesLink displayOn={displayOn} />,
    },
    {
      label: i18n.t("travel_acceptor", { ns: "Shared" }),
      link: ROUTES.travel_acceptor.queue,
      icon: <FontAwesomeIcon icon={Icons.personCircleCheck} />,
      displayOn: ["drawer", "navbar"],
    },
    {
      label: i18n.t("local_admin", { ns: "Shared" }),
      link: ROUTES.local_admin.queue,
      icon: <FontAwesomeIcon icon={Icons.userGear} />,
      displayOn: ["drawer", "navbar"],
    },
    {
      label: i18n.t("cost_group", { ns: "Shared" }),
      link: ROUTES.cost_group.queue,
      icon: <FontAwesomeIcon icon={Icons.layerGroup} />,
      displayOn: ["drawer", "navbar"],
    },
    {
      label: i18n.t("accounts_payable_acronym", { ns: "Shared" }),
      link: ROUTES.accounts_payable.panel,
      icon: <FontAwesomeIcon icon={Icons.fileInvoiceDollar} />,
      displayOn: ["drawer", "navbar"],
    },
    {
      label: i18n.t("local_hr_acronym", { ns: "Shared" }),
      link: ROUTES.local_hr.queue,
      icon: <FontAwesomeIcon icon={Icons.globeEurope} />,
      displayOn: ["drawer", "navbar"],
    },
    {
      label: i18n.t("profile", { ns: "Shared" }),
      link: ROUTES.user_profile,
      icon: <FontAwesomeIcon icon={Icons.user} />,
      displayOn: ["drawer", "footer"],
    },
    {
      label: i18n.t("faq", { ns: "Shared" }),
      link: ROUTES.faq,
      icon: <FontAwesomeIcon icon={Icons.question} />,
      displayOn: ["drawer", "footer"],
    },
    {
      label: i18n.t("contact", { ns: "Shared" }),
      link: ROUTES.contacts,
      icon: <FontAwesomeIcon icon={Icons.envelope} />,
      displayOn: ["drawer", "footer"],
    },
    {
      label: i18n.t("logs", { ns: "Shared" }),
      href: LINKS.logs,
      icon: null,
      displayOn: ["footer"],
    },
    {
      label: i18n.t("manual", { ns: "Shared" }),
      href: LINKS.manual,
      icon: <FontAwesomeIcon icon={Icons.circleInfo} />,
      displayOn: ["drawer", "footer"],
    },
  ];
  callback(links);
});
